const styles = (theme) => ({
  container: {
    padding: theme.spacing(2.5),
    '& hr:last-of-type': {
      display: 'none',
    },
  },
  item: {
    paddingBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-start',
  },
  disabledBtn: {
    fill: theme.color.grey_medium,
  },
  checkbox: {
    alignItems: 'left',
    marginLeft: theme.spacing(-1),
  },
  divider: {
    color: theme.color.grey_medium,
    width: '100%',
    margin: theme.spacing(-2, 1, 2, 0),
  },
});

export default styles;
